// extracted by mini-css-extract-plugin
module.exports = {"aboutContainer":"about-acko_aboutContainer__vMdLw","aboutBlur":"about-acko_aboutBlur__68oIJ","partnersDiv":"about-acko_partnersDiv__0KE8F"};